import { render } from "./HMenu.vue?vue&type=template&id=aad3d432&ts=true"
import script from "./HMenu.vue?vue&type=script&lang=ts"
export * from "./HMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__